import {cs} from "@Common/react/chain-services";
import {fragments} from "@Common/react/fragments";
import {TimeoutAction} from "@Common/react/timeout-action";
import {UseState} from "@Common/react/use-state";

export const RetryingLoad2 = ({load2, retryWhen, delay = 1000, maxAttempt = 3, next}) => cs(
    ["count", (_, next) => UseState({getInitValue: () => 0, next})],
    ({count}) => {
        const retrying = !load2.loading && retryWhen(load2.value) && count.value < maxAttempt;
        return fragments(
            next({
                ...load2,
                loading: load2.loading || retrying,
            }),

            !load2.loading && retrying && count.value < maxAttempt && (
                TimeoutAction({
                    delay,
                    action: () => {
                        load2.reset();
                        count.change(v=>v+1);
                    },
                })
            ),
        );
    },
);
